<template>
	<div v-bind:class="getMainClass()">
		<div class=" content-title-body bg-blue-dk">
			<div class="controls">
				<div class="control-label">
					<small v-bind:class="getLabelClass()">{{label}}</small>
				</div>
				<div v-if="deviceType === 'mobile' && !noScroll" class="scroll-handle">
					<div v-if="!isScrolled" v-on:click="scrollUp" class="control">
						<i class="material-icons md-24">keyboard_arrow_up</i>
					</div>
					<div v-else v-on:click="scrollDown" class="control">
						<i class="material-icons md-24">keyboard_arrow_down</i>
					</div>
				</div>
				<div v-on:click="routeClose" class="control right">
					<i class="material-icons md-18" title="close">close</i>
				</div>
			</div>
			<slot></slot>
		</div>
	</div>
</template>
<script>
export default {
	props:{
		// close may be a callback function to handle the close button click or string 'back' to do the default back behavior
		close:{}, 
		label:String,
		noScroll:Boolean,
		noSticky:Boolean,
		labelClass:String,
		variant:String,
	},
	computed: {
		deviceType:function(){
			return this.$store.state.device.type;
		},
		searchShown:function(){
			return this.$store.state.search.shown;
		}
	},
	created:function(){
		window.addEventListener('scroll', this.handleScroll);
	},
	data:function(){
		return {
			isScrolled:false
		}
	},
	destroyed:function(){
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods:{
		getLabelClass:function(){
			if (this.labelClass) return this.labelClass;
			return 'text-muted';
		},
		getMainClass:function(){
			let cl = 'content-title';
			if (this.deviceType === 'mobile' && !this.noSticky) cl += ' sticky-top';
			if (this.deviceType === 'mobile' && this.searchShown) cl += ' search-pt';
			if (this.variant === 'blue') cl += ' content-title-blue';
			return cl;
		},
		handleScroll:function(e){
			if (window.pageYOffset > 50){
				if (!this.isScrolled) this.$data.isScrolled = true;
			} else if (this.isScrolled) {
				this.$data.isScrolled = false;
			}
		},
		routeClose:function(){
			if (this.close === 'back'){
				this.$router.go(-1);
			} else if ({}.toString.call(this.close) === '[object Function]'){
				this.close();
			} else { // home
				this.$router.push({
					name: 'home', 
					params:{}
				});
			}
		},
		scrollUp:function(){
			this.$store.dispatch('SCROLL_CONTENT_TOP');
			this.$data.isScrolled = true;
		},
		scrollDown:function(){
			this.$store.dispatch('SCROLL_WINDOW_TOP');
			this.$data.isScrolled = false;
		}
	}
}
</script>
<style>
	.desktop .content-title-body{
		padding-top:44px;
	}
	.content-title{
		width:100%;
		border-bottom:2px solid #B61D1D;
	}
	.content-title.content-title-blue{
		border-bottom:2px solid #1A75D3;
	}
	.content-title h2{
		margin-bottom:0;
	}
	.content-title .controls{
		position:relative;
		height:34px;
		margin:0 -1rem;
	}
	.content-title-body{
		padding:0 1rem 0rem 1rem;
	}
	.control-label{
		padding-left:1rem;
		padding-top:0.25rem;
	}
	.control{
		width:34px;
		height:34px;
		line-height:32px;
		text-align:center;
		display:inline-block;
		cursor:pointer;
	}
	.control i{
		color:#788F9C;
	}
	.control:hover i{
		color:#FFF;
	}
	.control.right{
		position:absolute;
		right:0;
		top:0;
	}
	.scroll-handle{
		text-align:center;
		position:absolute;
		left:0;
		right:0;
		top:-2px;
	}
	.search-pt{
		padding-top:44px;
	}
</style>


// WEBPACK FOOTER //
// src/components/content/content-title.vue